import { generalizeContentType, M_CHANNEL } from './content-types.js';
import warning from 'fbjs/lib/warning';

export { createTargetFromVideo, createTargetFromCampaign, mergeTargets };
/**
 * Generate default ET target object for video content, as is used for emoji's events.
 *
 * @param {ContextDescription} object
 * @return {{object_type: *, object_id: number, object_title: string, object_code: *}}
 */
function createTargetFromVideo(object) {
  const target = {
    object_type: generalizeContentType(object.content_type),
    object_id: Number(object.object_id),
    object_title: object.title ?? '',
  };

  //RMI-916
  if (object.virtual_id) {
    target.virtual_object_id = object.virtual_id;
  } else if (object.channel_id && target.object_type === M_CHANNEL) {
    target.virtual_object_id = object.video_id.toString();
  }

  return target;
}
/**
 *
 * @param {Creative} creative
 * @return {ET.CampaignTarget}
 */
function createTargetFromCampaign(creative) {
  warning(creative.meta !== undefined, 'Creative parent meta is not defined');
  return {
    object_type: 'CAMPAIGN',
    object_id: creative.meta?.campaign?.id_hash ?? 0,
    object_code: creative.meta?.campaign?.id ?? '',
  };
}
/**
  * @param {ET.VideoTarget} videoTarget
  * @param {ET.CampaignTarget} campaignTarget
  * @return {ET.CampaignTarget}
  */
function mergeTargets(videoTarget, campaignTarget) {
  return {
    object_type: campaignTarget.object_type,
    object_id: campaignTarget.object_id,
    object_code: campaignTarget.object_code,

    root_id: videoTarget.object_id,
    root_code: videoTarget.object_type,
    virtual_object_id: videoTarget.virtual_object_id,
    object_title: videoTarget.object_title,
  };
}
